<!--
 * @Name: SelectMenu
 * @Description: 菜单权限
 * @Author: xiadongxue
 * @Date: 2021-10-25 19:02:15
 * @Editors: xiadongxue
-->
<template>
<div>
    <el-tree
        ref="elTree"
        node-key="menuId"
        :props="props"
        :data="options"
        default-expand-all
        :default-checked-keys="menuIds"
        check-strictly
        show-checkbox
        @check="changeValue"
    >
       <span slot-scope="{ node, data }">
            <el-tag v-if="data.ssoAppId" effect="plain" size="mini">{{getAppName(data.ssoAppId)}}</el-tag>
            {{node.label}}
        </span> 
    </el-tree>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import {
    arrayFlat
} from '@/assets/js/utils'
export default {
    name: 'selectMenu',
    props: {
        menuList: {
            type: Array,
            default: () => []
        },
        value: {
            type: Array,
            default: () => []
        },
        default: {
            type: Array,
            default: () => []
        },
        //是否为用户添加额外权限
        user: {
            type: Boolean,
            default: false
        },
        //是否为菜单禁用
        userDisabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            options: [],
            tempOptions: [],
            //数据绑定
            menuIds: [],
            props: {
                label: 'menuName',
                value: 'menuId',
            }
        }
    },
    computed: {
         ...mapGetters(['appList']),
    },
    created() {
        this.options = this.formatMenu(this.menuList)
        this.tempOptions = arrayFlat(this.options,'children')
        this.menuIds = this.value
    },
    methods: {
        //格式化菜单&处理按钮选择
        formatMenu(menu, flag) {
            if(!menu.length) {
                return []
            }
            if (flag) {
                menu.forEach(item => {
                    if (this.default.includes(item.menuId)) {
                        item.disabled = true
                    } else {
                        item.disabled = false
                    }
                    if (item.children && item.children.length) {
                        this.formatMenu(item.children, flag)
                    }
                })
            } else {
                menu = JSON.parse(JSON.stringify(menu))
                return menu.map(item => {
                    if (this.default.includes(item.menuId)) {
                        item.disabled = true
                    } else {
                        item.disabled = false
                    }
                    if (item.btnList && item.btnList.length) {
                        item.children = item.children && item.children.length ? item.children.concat(item.btnList) : item.btnList
                    }
                    if (item.children && item.children.length) {
                        item.children = this.formatMenu(item.children)
                    }
                    return item
                })
            }

        },
        changeValue(menu) {
            let flag = !this.menuIds.includes(menu.menuId)
            //添加联动子节点
            if (flag) {
                //当前节点
                this.menuIds.push(menu.menuId)
                //子节点
                menu.childIds && menu.childIds.forEach(item => {
                    //不重复添加角色本身携带的菜单权限
                    if (!this.menuIds.includes(item) && !this.default.includes(item)) {
                        this.menuIds.push(item)
                    }
                })
                if(!this.userDisabled) {
                    menu.parentIds && menu.parentIds.forEach(item => {
                        //不重复添加角色本身携带的菜单权限
                        if (!this.menuIds.includes(item) && !this.default.includes(item)) {
                            this.menuIds.push(item)
                        }
                    })
                }
            } else {
                //当前节点
                let index = this.menuIds.findIndex(i => i === menu.menuId)
                this.menuIds.splice(index, 1)
                //取消选中联动子节点
                menu.childIds && menu.childIds.forEach(item => {
                    //角色本身携带的菜单权限不可取消
                    let index = this.menuIds.findIndex(i => i === item)
                    if (index !== -1 && !this.default.includes(item)) {
                        this.menuIds.splice(index, 1)
                    }
                })
            }
            //更新渲染选中节点
            this.$refs.elTree && this.$refs.elTree.setCheckedKeys(this.menuIds,true)
            this.$emit('update:value', this.menuIds)
        },
        getAppName(id) {
            return this.appList.find(item => item.ssoAppId === id).appName
        }
    },
    watch: {
        menuList(newVal) {
            if (newVal) {
                this.options = this.formatMenu(newVal)
            }
        },
        default: {
            deep: true,
            handler() {
                this.formatMenu(this.options, true)
            }
        },
        value(newVal) {
            this.menuIds = newVal
            //更新渲染选中节点
            this.$refs.elTree && this.$refs.elTree.setCheckedKeys(this.menuIds,true)
        }
    }
}
</script>
<style lang="scss">
.el-tree__empty-block {
    width: 200px;
    min-height: 40px;
}
</style>
